import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify'; // Importa l'istanza di Vuetify
import '@mdi/font/css/materialdesignicons.css';
import store from './store';  // Importa lo store
import './main.css'; // Assicurati che il percorso sia 
const app = createApp(App);

app.use(router);
app.use(vuetify); // Usa Vuetify
app.use(store);  // Utilizza lo store

app.mount('#app');
